// @vendors
const moment = require('moment');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { recordLink, PROC_END } = require('utilities/tagging');
const { getFormattedLanguage } = require('../utilities/RALanguageHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { RA_MOVEMENTS_FILTER_ALL } = require('../raConstants/index');

const changeLastMovementFilter = (key, value) => ({
    type: actionTypes.RA_LAST_MOVEMENT_CHANGE_FILTER,
    payload: {
        key,
        value,
    },
});

const lastMovementSuccess = (data, portfolioId) => ({
    type: actionTypes.RA_GET_LAST_MOVEMENT_SUCCESS,
    payload: {
        data,
        portfolioId,
    },
});

const lastMovementFailure = error => ({
    type: actionTypes.RA_GET_LAST_MOVEMENT_FAILURE,
    payload: {
        error,
    },
});

const requestLastMovementInProgress = () => ({
    type: actionTypes.RA_GET_LAST_MOVEMENT_REQUEST,
});

const requestLastMovement = (portfolioId, isFilterDateSet) => (
    dispatch,
    getState,
) => {
    dispatch(requestLastMovementInProgress());
    const filters = getState().raLastMovement.getIn([
        'lastMovementsRow',
        'filter',
    ]);
    const portfolioModalValue = filters.get('portfolioModalValue');
    const typeModalValue = filters.get('typeModalValue');
    const type =
        typeModalValue !== RA_MOVEMENTS_FILTER_ALL ? typeModalValue : '';
    let startDate, endDate;

    if (isFilterDateSet) {
        startDate = moment(filters.getIn(['date', 'from'])).format(
            'YYYY-MM-DD',
        );
        endDate = moment(filters.getIn(['date', 'to'])).format('YYYY-MM-DD');
    }

    let query = {};
    portfolioId !== '' ? (query['portfolioId'] = portfolioId) : null;
    startDate !== '' && startDate !== undefined
        ? (query['startDate'] = startDate)
        : null;
    endDate !== '' && endDate !== undefined
        ? (query['endDate'] = endDate)
        : null;
    type !== '' ? (query['type'] = type) : null;
    const language = getFormattedLanguage();
    const requestData = {
        query,
        header: {
            'Accept-Language': language,
        },
    };

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raGetLastMovement'),
        requestData,
    )
        .then(response => {
            dispatch(lastMovementSuccess(response, portfolioId));
            if (isFilterDateSet) {
                const portfolioName = !!portfolioModalValue
                    ? portfolioModalValue
                    : RA_MOVEMENTS_FILTER_ALL;
                const eventTag = portfolioName + ' ' + typeModalValue;
                recordLink('robo-filtro-ordenes', PROC_END, eventTag);
            }
        })
        .catch(error => {
            if (error.error) {
                dispatch(lastMovementFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const setFilter = filter => ({
    type: actionTypes.RA_GET_LAST_MOVEMENT_SET_FILTER,
    payload: {
        filter,
    },
});

const removeFilter = filter => ({
    type: actionTypes.RA_LAST_MOVEMENT_CLAER_FILTER,
    payload: {
        filter,
    },
});

module.exports = {
    changeLastMovementFilter,
    requestLastMovement,
    setFilter,
    removeFilter,
};
